import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import {
  GuideDate,
  GuideDescription,
  GuideDetails,
  GuideHeader,
  GuideInfo,
  TimeAndPlace,
} from 'entities/excursions/components'
import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'
import { orderExcursionsStore } from 'entities/excursions/models/order-excursions/order-excursions-store'
import { setSettingForApp } from 'entities/user/module/app-settings'

import { ExcursionsList } from 'shared/api/excursions/list'
import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { ShareKeys } from 'shared/constants'
import GhostImage from 'shared/images/ghost.png'
import { checkUserAuth } from 'shared/lib/checkUserAuth'
import { prepareDateFormat } from 'shared/lib/dateFormat'
import { getRedirectUrl } from 'shared/lib/getRedirectUrl'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { Carousel } from 'shared/ui/carousel'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

const GuidePage = () => {
  const navigate = useNavigate()

  const { id } = useParams()

  const [excursionDetails, setExcursionDetails] =
    useState<IExcursionDetails | null>(null)

  const { t } = useTranslation()

  const getCurrentExcursion = async () => {
    try {
      const { data: Excursion } = await ExcursionsList.getExcursionById(id)

      const excursion = Excursion?.data

      setExcursionDetails(excursion)

      listExcursionStore.onSetCurrentExcursionsDetail(excursion)

      const preparedFindExcursion = {
        departure_date: excursion?.departure_date,
        direction: excursion?.direction?.name,
        name: '',
      }

      findExcursionsStore.onSetExcursion(preparedFindExcursion)
    } catch {}
  }

  const navigateHandler = async () => {
    const navigatePath = RoutingPaths.excursion.orderDetail.path()
    const redirectUrl = getRedirectUrl(navigatePath)

    await checkUserAuth({
      redirectUrl,
      onSuccess: () => {
        orderExcursionsStore.onPeopleQuantityChange(1)
        navigate(navigatePath)
      },
      onError: () => {
        const payload = {
          excursionDetails: excursionDetails,
        }
        void setSettingForApp({
          key: ShareKeys.excursion,
          value: JSON.stringify(payload),
        })
      },
    })
  }

  const onCalendar = () => {
    navigate({
      pathname: RoutingPaths.excursion.calendar.path(),
      search: `excursion=${excursionDetails?.reference_book_id}`,
    })
  }

  const onGoBack = () => {
    navigate(RoutingPaths.excursion.search.path())
  }

  useEffect(() => {
    getCurrentExcursion()
  }, [])

  return (
    <>
      {!excursionDetails ? (
        <Loader
          type="excursions"
          marginTop={200}
        />
      ) : (
        <>
          <HeaderGoBack
            title={t('detail')}
            onGoBack={onGoBack}
            buttonWhite
          />

          <Carousel
            images={excursionDetails.excursion_images}
            errorImage={GhostImage}
          />

          <div className="container">
            <div className={s.content}>
              <GuideHeader excursionDetails={excursionDetails} />

              <GuideDate
                onClick={onCalendar}
                value={prepareDateFormat(excursionDetails?.departure_date)}
              />

              <GuideInfo
                excursionDetails={excursionDetails}
                bonusAmount={excursionDetails.bonus_amount}
              />

              <GuideDescription excursionDetails={excursionDetails} />

              <GuideDetails excursionDetails={excursionDetails} />

              <TimeAndPlace excursionDetails={excursionDetails} />

              <ButtonContinue onClick={navigateHandler}>
                <span className={s.continue}>{t('continue')}</span>
              </ButtonContinue>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default GuidePage
